import debouncedSaveTemplate from 'fantastic/lib/debouncedSaveTemplate';
import sections from 'fantastic/lib/sections';

const findDestinationColumn = (target, stateSections) => {
  return (
    sections.columnByItemId(target.id, stateSections) ||
    sections.byId(target.id, stateSections)
  );
};

const findSelectedElement = (destinationColumn, target, data) => {
  if (!destinationColumn) return null;

  if (destinationColumn.items) {
    let destinationIndex = destinationColumn.items.findIndex(item => item.id === target.id);

    if (target.place === 'down') {
      destinationIndex += 1;
    } else if (target.place === 'up') {
      if (destinationColumn.items.length === 1) {
        destinationIndex += 1;
      } else {
        destinationIndex -= 1;
      }
    }

    return destinationColumn.items.at(destinationIndex);
  } else {
    destinationColumn.items = [data];
    return destinationColumn.items.at(-1);
  }
};

export default ({ data }) =>
  (dispatch, getState) => {
    const { target } = window;
    dispatch({ type: 'SECTIONS/ADD_ITEM', payload: { data, target } });

    const stateSections = getState().sections;
    const destinationColumn = findDestinationColumn(target, stateSections);

    const selectedElement = findSelectedElement(destinationColumn, target, data);

    if (selectedElement && selectedElement.id) {
      dispatch({ type: "SELECTED_NODE/SET", payload: selectedElement.id });
      dispatch({ type: "SECTIONS/NODE/SELECTED", payload: { id: selectedElement.id, selected: true } });
    }

    debouncedSaveTemplate(dispatch, getState);
  };